/* eslint-disable no-unused-vars */

<template>
  <div
    class="fixed inset-x-0 bottom-0 px-4 pb-4 z-90 sm:inset-0 sm:flex sm:items-center sm:justify-center"
  >
    <!--
            Background overlay, show/hide based on modal state.

            Entering: "ease-out duration-300"
            From: "opacity-0"
            To: "opacity-100"
            Leaving: "ease-in duration-200"
            From: "opacity-100"
            To: "opacity-0"
        -->
    <div class="fixed inset-0 transition-opacity">
      <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
    </div>

    <!--
            Modal panel, show/hide based on modal state.

            Entering: "ease-out duration-300"
            From: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            To: "opacity-100 translate-y-0 sm:scale-100"
            Leaving: "ease-in duration-200"
            From: "opacity-100 translate-y-0 sm:scale-100"
            To: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        -->
    <div
      class="relative px-4 pt-5 pb-4 overflow-hidden transition-all transform bg-white rounded-lg shadow-xl sm:max-w-lg sm:w-full sm:p-6"
      role="dialog"
      aria-modal="true"
      aria-labelledby="modal-headline"
    >
      <div class="absolute top-0 right-0 hidden pt-4 pr-4 sm:block">
        <button
          @click="close"
          type="button"
          class="text-gray-400 transition duration-150 ease-in-out hover:text-gray-500 focus:outline-none focus:text-gray-500"
          aria-label="Close"
        >
          <svg
            class="w-6 h-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      </div>
      <div class="sm:flex sm:items-start">
        <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
          <h3
            class="text-lg font-medium leading-6 text-gray-900"
            id="modal-headline"
          >
            Report
          </h3>

          <div class="flex flex-wrap">
            <div class="w-full">
              <p class="mt-4 text-sm leading-5 text-gray-700">
                Tipo di report
              </p>

              <select
                v-model="selectedReportType"
                class="block w-full mt-1 transition duration-150 ease-in-out form-select sm:text-sm sm:leading-5"
              >
                <option
                  v-for="type in avaibleReportTypes"
                  v-bind:value="type.value"
                  :key="type.value"
                >
                  {{ type.name }}
                </option>
              </select>

              <p class="mt-4 mb-1 text-sm leading-5 text-gray-700">
                Includi nel report i seguneti pasti
              </p>

              <div v-for="type in menuTypes" :key="type.slug">
                <div class="absolute flex items-center h-5">
                  <input
                    v-model="selectedMenuTypes"
                    :id="'type_' + type.slug"
                    :name="'type_' + type.slug"
                    :value="type.slug"
                    type="checkbox"
                    class="w-4 h-4 text-indigo-600 transition duration-150 ease-in-out form-checkbox"
                  />
                </div>
                <div class="text-sm leading-5 pl-7">
                  <label
                    :for="'type_' + type.slug"
                    class="font-medium text-gray-700"
                  >
                    {{ type.name }}
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
        <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
          <button
            @click="generate()"
            type="button"
            class="inline-flex justify-center w-full px-4 py-2 text-base font-medium leading-6 text-white transition duration-150 ease-in-out bg-white bg-green-400 border rounded-md shadow-sm border-gray-50 hover:text-gray-50 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue sm:text-sm sm:leading-5 hover:bg-green-500 focus:border-green-400 focus:shadow-outline-green"
          >
            Scarica PDF
          </button>
        </span>
        <span class="flex w-full mt-3 rounded-md shadow-sm sm:mt-0 sm:w-auto">
          <button
            @click="close"
            type="button"
            class="inline-flex justify-center w-full px-4 py-2 text-base font-medium leading-6 text-gray-700 transition duration-150 ease-in-out bg-white border border-gray-300 rounded-md shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue sm:text-sm sm:leading-5"
          >
            Annulla
          </button>
        </span>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable no-unused-vars */
import jsPDF from "jspdf";
import Order from "./../apis/Order";
import { format } from "date-fns";

export default {
  name: "ModalPrintReport",
  props: {
    locationid: {
      type: String,
      required: true,
    },
    /*
        reportHotel:{
            type: Object,
            required: true
        },
        */
    menuTypes: {
      type: Array,
      required: true,
    },
    eventclose: {
      type: String,
      default: "",
    },
    date: {
      type: String,
      default: "",
    },
    filters: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      avaibleReportTypes: [
        { name: "Riepilogo", value: "summary" },
        { name: "Dettaglio", value: "detail" },
      ],
      selectedReportType: "summary",
      selectedMenuTypes: [],
      pdf: {
        font1: "",
        font2: "",
        positionY: 0,
        lineSpacing: 1.6,

        fontSizeDate: 20,
        fontSizeRoom: 20,
        fontSizeMenuType: 16,
        fontSizeCategoryName: 14,
        fontSizeDishName: 12,
        fontSizeComment: 10,
        fontSizeGeneralComment: 10,

        marginX: 24,
        marginY: 10,
        betweenMenuTypeSpace: 15,
        betweenCategoriesSpace: {
          report: 8,
          details: 3,
        },
        betweenRoomsSpace: 10,
      },
    };
  },
  methods: {
    generate: function() {
      if (this.selectedReportType == "summary") {
        this.generatePdf();
      }

      if (this.selectedReportType == "detail") {
        this.generatePdfRooms();
      }
    },

    calculateLineHeight: function(doc) {
      this.pdf.pageHeight = doc.internal.pageSize.height;
      this.pdf.pageWidth = doc.internal.pageSize.width;
      this.pdf.maxw = this.pdf.pageWidth - this.pdf.marginX * 2;

      this.pdf.deltaYRoom =
        (this.pdf.fontSizeRoom * this.pdf.lineSpacing * 25.4) / 72;
      this.pdf.deltaYMenuType =
        (this.pdf.fontSizeMenuType * this.pdf.lineSpacing * 25.4) / 72;
      this.pdf.deltaYCategoryName =
        (this.pdf.fontSizeCategoryName * this.pdf.lineSpacing * 25.4) / 72;
      this.pdf.deltaYDishName =
        (this.pdf.fontSizeDishName * this.pdf.lineSpacing * 25.4) / 72;
      this.pdf.deltaYDishComment = (this.pdf.fontSizeComment * 1.3 * 25.4) / 72;
      this.pdf.deltaYGeneralComment =
        (this.pdf.fontSizeGeneralComment * 1.3 * 25.4) / 72;
    },

    resetPdf: function() {
      this.pdf.positionY = 0;
    },

    generatePdf: async function() {
      this.resetPdf();

      var doc = new jsPDF();

      this.calculateLineHeight(doc);

      this.pdf.positionY = this.pdf.marginY;
      doc.setFontSize(this.pdf.fontSizeDate);

      let deltaYDate =
        (this.pdf.fontSizeDate * this.pdf.lineSpacing * 25.4) / 72;
      this.pdf.positionY += deltaYDate;
      let dateSplit = this.date.split("-");
      doc.text(
        dateSplit[2] + "/" + dateSplit[1] + "/" + dateSplit[0],
        105,
        this.pdf.positionY,
        null,
        null,
        "center"
      );

      await Order.getReportHotel(this.locationid, this.filters).then(
        (response) => {
          this.reportHotel = response.data;
        }
      );

      console.log(this.reportHotel);
      console.log(this.reportHotel.summary.length);

      for (let i = 0; i < this.reportHotel.summary.length; i++) {
        let menuType = this.reportHotel.summary[i];

        if (!this.selectedMenuTypes.includes(menuType.slug)) {
          continue;
        }

        //if(i != 0){
        doc.setLineWidth(0.1);
        doc.setDrawColor(192, 192, 192);

        doc.setLineDash([1]);
        doc.line(
          0,
          this.pdf.positionY + this.pdf.betweenCategoriesSpace.report,
          210,
          this.pdf.positionY + this.pdf.betweenCategoriesSpace.report
        );
        //}

        let categories = Object.keys(this.reportHotel.summary[i].categories);
        for (let j = 0; j < categories.length; j++) {
          let category = categories[j];
          console.log(category);
          for (
            let k = 0;
            k < this.reportHotel.summary[i].categories[category].length;
            k++
          ) {
            let dish = this.reportHotel.summary[i].categories[category][k];
            this.printDish(
              doc,
              j == 0 && k == 0 ? menuType : null,
              k == 0 ? category : null,
              dish
            );
          }
        }
      }
      doc.save("Report-" + this.date + ".pdf");
    },

    printDish(doc, menuType, category, dish) {
      doc.setFontType("normal");

      let menuTypeH =
        menuType != null
          ? this.pdf.deltaYMenuType + this.pdf.betweenMenuTypeSpace
          : 0;
      let categoryH =
        category != null
          ? this.pdf.deltaYCategoryName + this.pdf.betweenCategoriesSpace.report
          : 0;

      doc.setFontSize(this.pdf.fontSizeComment);

      let textLinesGeneralComment = [];
      let generalComments = null;
      if (menuType != null) {
        generalComments = menuType.rooms_note.map(
          (x) => "CAMERA " + x.room + ": " + x.note
        );
        if (generalComments.length > 0) {
          textLinesGeneralComment = doc.splitTextToSize(
            generalComments.join("  -  "),
            this.pdf.maxw
          );
        }
      }

      let textLinesComment = [];
      let comments = dish.comments.map(
        (x) => "CAMERA " + x.room + ": " + x.comment
      );
      if (comments.length > 0) {
        textLinesComment = doc.splitTextToSize(
          comments.join("  -  "),
          this.pdf.maxw
        );
      }

      let totalH =
        this.pdf.marginY +
        menuTypeH +
        categoryH +
        this.pdf.deltaYDishName +
        this.pdf.deltaYDishComment * textLinesComment.length +
        this.pdf.deltaYGeneralComment * textLinesGeneralComment.length;

      if (
        this.pdf.positionY + totalH >=
        this.pdf.pageHeight - this.pdf.marginY
      ) {
        doc.addPage();
        this.pdf.positionY = this.pdf.marginY;
      } else if (category != null) {
        this.pdf.positionY += this.pdf.betweenCategoriesSpace.report; //?????oppure si può fare uguale a deltaYCategoryName
      }

      if (menuType != null) {
        this.pdf.positionY += this.pdf.deltaYMenuType;
        //doc.setFontSize(this.pdf.fontSizeMenuType);
        this.writeText(
          doc,
          this.pdf.fontSizeMenuType,
          this.getmenuTypeName(menuType.slug),
          { align: "center" }
        );

        //doc.text( this.getmenuTypeName(menuType.slug), 105, this.pdf.positionY,  null, null, "center");
      }

      if (generalComments != null) {
        //doc.setTextColor(220,20,60);
        //doc.setFontSize(this.pdf.fontSizeGeneralComment);
        textLinesGeneralComment.forEach((lineText) => {
          this.pdf.positionY += this.pdf.deltaYGeneralComment;
          this.writeText(doc, this.pdf.fontSizeGeneralComment, lineText, {
            align: "center",
            color: { r: 220, g: 20, b: 60 },
          });
          //doc.text(lineText, 105, this.pdf.positionY,  null, null, "center");
        });
      }

      doc.setTextColor(0, 0, 0);

      if (category != null) {
        this.pdf.positionY += this.pdf.deltaYCategoryName;
        //doc.setFontSize(this.pdf.fontSizeCategoryName);
        //doc.text(category, this.pdf.marginX, this.pdf.positionY);
        this.writeText(doc, this.pdf.fontSizeCategoryName, category);
      }

      this.pdf.positionY += this.pdf.deltaYDishName;
      //doc.setFontSize(this.pdf.fontSizeDishName);
      //doc.text("n. " + dish.qty + " " + dish.name, this.pdf.marginX + 5, this.pdf.positionY);
      this.writeText(
        doc,
        this.pdf.fontSizeDishName,
        "n. " + dish.qty + " " + dish.name,
        { positionX: this.pdf.marginX + 5 }
      );

      if (comments.length > 0) {
        //doc.setTextColor(220,20,60);
        //doc.setFontSize(this.pdf.fontSizeComment);
        textLinesComment.forEach((lineText) => {
          this.pdf.positionY += this.pdf.deltaYDishComment;
          this.writeText(doc, this.pdf.fontSizeComment, lineText, {
            positionX: this.pdf.marginX + 10,
            color: { r: 220, g: 20, b: 60 },
          });
          //doc.text(lineText, this.pdf.marginX + 10, this.pdf.positionY);
        });
      }
    },

    calculateRoomHeight: function(roomOrders, doc) {
      let countMenuType = roomOrders.length;
      let countSpaceCategory = 0;
      let countRowComment = 0;
      let countDish = 0;
      for (let i = 0; i < roomOrders.length; i++) {
        let textLinesGeneralComment = [];
        if (roomOrders[i].note != null) {
          doc.setFontSize(this.pdf.fontSizeComment);
          textLinesGeneralComment = doc.splitTextToSize(
            "NOTE: " + roomOrders[i].note,
            this.pdf.maxw
          );
        }
        countRowComment += textLinesGeneralComment.length;

        let currentCategory = -1;
        let orderDetails = roomOrders[i].order_detail;

        countDish += orderDetails.length;
        //console.log("countDish"+countDish)
        //console.log(orderDetails)

        for (let j = 0; j < orderDetails.length; j++) {
          if (orderDetails[j].dish_category_id != currentCategory) {
            currentCategory = orderDetails[j].dish_category_id;
            countSpaceCategory++;
          }

          let textLinesComment = [];
          if (orderDetails[j].comment != null) {
            doc.setFontSize(this.pdf.fontSizeComment);
            textLinesComment = doc.splitTextToSize(
              "NOTE: " + orderDetails[j].comment,
              this.pdf.maxw
            );
          }
          countRowComment += textLinesComment.length;
        }
      }
      //console.log("Calcolo:"+this.pdf.deltaYRoom +"+"+ this.pdf.deltaYMenuType +"*"+ countMenuType +"+"+ this.pdf.betweenCategoriesSpace +"*"+ countSpaceCategory +"+"+ this.pdf.deltaYDishName +"*"+ countDish +"+"+ this.pdf.deltaYGeneralComment +"*"+ countRowComment)
      return (
        this.pdf.deltaYRoom +
        this.pdf.deltaYMenuType * countMenuType +
        this.pdf.betweenCategoriesSpace.details * countSpaceCategory +
        this.pdf.deltaYDishName * countDish +
        this.pdf.deltaYGeneralComment * countRowComment
      );
    },

    generatePdfRooms: async function() {
      this.resetPdf();

      var doc = new jsPDF();

      this.calculateLineHeight(doc);

      this.pdf.positionY = this.pdf.marginY;
      // doc.setFontSize(this.pdf.fontSizeDate);
      // doc.text(this.date, 105, this.pdf.positionY, null, null, "center");

      let orders = {};
      await Order.getOrders(this.locationid, {
        type: this.filters.type,
        menuTypeSlug: this.selectedMenuTypes.join(","),
        date: this.filters.date,
        orderby: this.filters.orderby,
        limitpaginate: 200,
      })
        .then((response) => {
          orders = response.data.data;

          for (let i = 0; i < orders.length; i++) {
            let room = orders[i].room;
            let j = 1;
            while (i + j < orders.length && orders[i + j].room == room) {
              j++;
            }

            let roomsOrders = [];
            for (let k = 0; k < j; k++) {
              roomsOrders.push(orders[i + k]);
            }

            i = i + j - 1;

            this.printDishRooms(roomsOrders, doc);
          }
          doc.save("Report-" + this.date + ".pdf");

          this.$store.dispatch("updateSpinner", false);
        })
        .catch(() => {
          this.$store.dispatch("updateSpinner", false);
        });
    },

    writeText(doc, fontSize, text, settings) {
      settings = settings || {};
      settings.align = settings.align || "left";
      settings.positionY = settings.positionY || this.pdf.positionY;
      settings.positionX = settings.positionX || this.pdf.marginX;
      settings.color = settings.color || { r: 0, g: 0, b: 0 };

      doc.setTextColor(settings.color.r, settings.color.g, settings.color.b);

      doc.setFontSize(fontSize);
      if (settings.positionY > this.pdf.pageHeight - this.pdf.marginY) {
        doc.addPage();
        this.pdf.positionY = this.pdf.marginY;
        settings.positionY = this.pdf.positionY;
      }
      //console.log(settings.align)

      if (settings.align == "center")
        doc.text(text, 105, settings.positionY, null, null, "center");
      else {
        doc.text(text, settings.positionX, settings.positionY);
      }
      //doc.text(lineText, this.pdf.marginX + 10, this.pdf.positionY);
    },

    printDishRooms(roomOrders, doc) {
      doc.setFontType("normal");
      doc.setTextColor(0, 0, 0);

      let totalH = this.calculateRoomHeight(roomOrders, doc);
      //console.log("--->"+totalH);
      //console.log(this.pdf.positionY + totalH + this.pdf.betweenRoomsSpace)
      //console.log(this.pdf.positionY + totalH + this.pdf.betweenRoomsSpace);
      //console.log(this.pdf.pageHeight - this.pdf.marginY);
      if (
        this.pdf.positionY + totalH + this.pdf.betweenRoomsSpace >=
        this.pdf.pageHeight - this.pdf.marginY
      ) {
        doc.addPage();
        this.pdf.positionY = this.pdf.marginY;
      } else if (this.pdf.positionY != this.pdf.marginY) {
        this.pdf.positionY += this.pdf.betweenRoomsSpace;

        doc.setLineWidth(0.1);
        doc.setDrawColor(192, 192, 192);

        doc.setLineDash([1]);
        doc.line(0, this.pdf.positionY, 210, this.pdf.positionY);
      }
      //doc.text("____________________________________________", 105, this.pdf.positionY + totalH,  null, null, "center");

      this.pdf.positionY += this.pdf.deltaYRoom;
      //console.log("deltaYRoom" + this.pdf.deltaYRoom);
      //doc.setFontSize(this.pdf.fontSizeRoom);
      //doc.text(roomOrders[0].order_date + " Camera: " + roomOrders[0].room , 105, this.pdf.positionY,  null, null, "center");
      this.writeText(
        doc,
        this.pdf.fontSizeRoom,
        format(new Date(Date.parse(roomOrders[0].order_date)), "dd/MM/yyyy") +
          " Camera: " +
          roomOrders[0].room,
        { align: "center" }
      );

      for (let i = 0; i < roomOrders.length; i++) {
        this.pdf.positionY += this.pdf.deltaYMenuType;
        //console.log("deltaYMenuType" + this.pdf.deltaYMenuType);
        //doc.setFontSize(this.pdf.fontSizeMenuType);
        //doc.text(roomOrders[i].menu_type_name, 105, this.pdf.positionY,  null, null, "center");
        this.writeText(
          doc,
          this.pdf.fontSizeMenuType,
          roomOrders[i].menu_type_name,
          { align: "center" }
        );

        let textLinesGeneralComment = [];
        if (roomOrders[i].note != null && roomOrders[i].note != "") {
          doc.setFontSize(this.pdf.fontSizeComment);
          textLinesGeneralComment = doc.splitTextToSize(
            "NOTE: " + roomOrders[i].note,
            this.pdf.maxw
          );
        }

        textLinesGeneralComment.forEach((lineText) => {
          this.pdf.positionY += this.pdf.deltaYDishComment;
          //console.log("deltaYDishComment" + this.pdf.deltaYDishComment);
          //doc.text(lineText, this.pdf.marginX + 10, this.pdf.positionY);
          this.writeText(doc, this.pdf.fontSizeComment, lineText, {
            align: "center",
            color: { r: 220, g: 20, b: 60 },
          });
        });

        let currentCategory = -1;
        let orderDetails = roomOrders[i].order_detail;

        for (let j = 0; j < orderDetails.length; j++) {
          let newCategory = false;
          if (orderDetails[j].dish_category_id != currentCategory) {
            currentCategory = orderDetails[j].dish_category_id;
            newCategory = true;
          }

          if (newCategory) {
            this.pdf.positionY += this.pdf.betweenCategoriesSpace.details;
          }
          this.pdf.positionY += this.pdf.deltaYDishName;

          //doc.setFontSize(this.pdf.fontSizeDishName);
          //doc.text("n." + orderDetails[j].qty + " " + orderDetails[j].name, this.pdf.marginX, this.pdf.positionY);
          this.writeText(
            doc,
            this.pdf.fontSizeDishName,
            "n." + orderDetails[j].qty + " " + orderDetails[j].name
          );

          let textLinesComment = [];
          if (
            orderDetails[j].comment != null &&
            orderDetails[j].comment != ""
          ) {
            doc.setFontSize(this.pdf.fontSizeComment);
            textLinesComment = doc.splitTextToSize(
              "NOTE: " + orderDetails[j].comment,
              this.pdf.maxw
            );
          }
          textLinesComment.forEach((lineText) => {
            this.pdf.positionY += this.pdf.deltaYDishComment;
            //console.log("deltaYDishComment" + this.pdf.deltaYDishComment);
            //doc.text(lineText, this.pdf.marginX + 10, this.pdf.positionY);

            this.writeText(doc, this.pdf.fontSizeComment, lineText, {
              positionX: this.pdf.marginX + 10,
              color: { r: 220, g: 20, b: 60 },
            });
          });
        }
      }
    },

    getmenuTypeName(slug) {
      switch (slug) {
        case "breakfast":
          return "Colazione";
        case "lunch":
          return "Pranzo";
        case "dinner":
          return "Cena";
      }
      return slug;
    },

    setDimensions: function(perc) {
      this.pdf.fontSizeTitle = this.pdf.baseFontSizeTitle * perc;
      this.pdf.fontSizeDesc = this.pdf.baseFontSizeDesc * perc;
      this.pdf.fontSizePowerd = this.pdf.baseFontSizePowerd * perc;
      this.pdf.qrSize = this.pdf.baseQrSize * perc;
      this.pdf.qRMarginQrTop = this.pdf.baseQqRMarginQrTop * perc;
      this.pdf.spaceBetweenLang = this.pdf.baseSpaceBetweenLang * perc;
    },

    close: function() {
      this.$root.$emit(this.eventclose);
    },
  },
  mounted: function() {
    this.selectedMenuTypes = this.menuTypes.map((x) => x.slug);
  },
};
</script>
